import { Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { AddressType, PersonalClient } from "types";
import styled from "styled-components";
import EditAddressHistoryItem from "pages/clientPortfolio/personalClient/personalClientInformation/components/EditAddressHistoryItem";
import AddAddressHstoryItem from "pages/clientPortfolio/personalClient/personalClientInformation/components/AddAddressHistoryItem";
import AddressHistoryList from "pages/clientPortfolio/personalClient/personalClientInformation/components/AddressHistoryList";

type ManageAddressProps = {
  client: PersonalClient;
  onEditAddress(oldAddress: AddressType, updatedAddress: AddressType): void;
  onClose(): void;
  onAddAddress(newAddress: AddressType): void;
  onDeleteAddress(address: AddressType): void;
  isReadOnlyView: boolean;
};

export default function ManageAddress(props: ManageAddressProps) {
  const [state, setState] = useState<PersonalClient>(props.client);

  type AddressDialogProps = {
    openNewAddressDialog: boolean;
    openEditAddressDialog: boolean;
    addressHistoryItem: AddressType;
  };

  const [
    addressDialogProps,
    setAddressDialogProps,
  ] = useState<AddressDialogProps>({
    openNewAddressDialog: false,
    openEditAddressDialog: false,
    addressHistoryItem: {},
  });

  const addHistory = state.information?.clientAddressHistory;

  useEffect(() => {
    setState(props.client);
  }, [props.client]);

  return (
    <div>
      <Header>
        <Typography style={{ flexGrow: 1 }} variant={"h6"}>
          Manage Address
        </Typography>
        <Button
          variant="contained"
          onClick={() => {
            setAddressDialogProps({
              ...addressDialogProps,
              openNewAddressDialog: true,
            });
          }}
          disabled={props.isReadOnlyView}
        >
          Add
        </Button>
      </Header>

      <ContentContainer>
        <AddressHistoryList
          addressHistory={addHistory ?? []}
          onEdit={(addressHistoryItem) => {
            setAddressDialogProps({
              ...addressDialogProps,
              openEditAddressDialog: true,
              addressHistoryItem: addressHistoryItem,
            });
          }}
          onDeleteAddress={(address) => {
            props.onDeleteAddress(address);
          }}
          isReadOnlyView={props.isReadOnlyView}
        />
      </ContentContainer>
      <ButtonContainer>
        <Button
          onClick={() => {
            props.onClose();
          }}
        >
          Close
        </Button>
      </ButtonContainer>
      {addressDialogProps.openNewAddressDialog && (
        <AddAddressHstoryItem
          onCancel={() => {
            setAddressDialogProps({
              ...addressDialogProps,
              openNewAddressDialog: false,
            });
          }}
          onAdd={(clientNewAddress) => {
            props.onAddAddress(clientNewAddress);
            setAddressDialogProps({
              ...addressDialogProps,
              openNewAddressDialog: false,
            });
          }}
        />
      )}
      {addressDialogProps.openEditAddressDialog && (
        <EditAddressHistoryItem
          addressHistoryItem={addressDialogProps.addressHistoryItem}
          onEditAddressHistoryItem={(oldAddress, updatedAddress) => {
            props.onEditAddress(oldAddress, updatedAddress);
            setAddressDialogProps({
              ...addressDialogProps,
              openEditAddressDialog: false,
            });
          }}
          onCancel={() => {
            setAddressDialogProps({
              ...addressDialogProps,
              openEditAddressDialog: false,
            });
          }}
        />
      )}
    </div>
  );
}

const Header = styled.div`
  display: flex;
  padding: 1em 0.25em;
`;

const ContentContainer = styled.div`
  min-height: 200px;
  min-width: 600px;
  justify-content: stretch;
  display: flex;
`;

const ButtonContainer = styled.div`
  display: flex;
  margin: 2em auto 0em auto;
  justify-content: center;
`;
